import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../../shared";
import { RemoveAlertsRequestModel } from "../RemoveAlertsRequestModel";
import { DataService_Student_Alerts } from "../shared/data.service";

@Component({
	selector: "caass-student-alerts-table",
	templateUrl: "./student-alerts-table.component.html",
	styleUrls: ["./student-alerts-table.component.css"],
})
export class StudentAlertsTableComponent implements OnInit {
	constructor(private userService: UserService, private studentAlertService: DataService_Student_Alerts, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.loadCurrentYearStartDate();

		this.UpdateFilterLists();
	}

	ngOnChanges() {
		this.UpdateFilterLists();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() MainLoading: any = false;

	@Output() RefreshTable: EventEmitter<any> = new EventEmitter();
	@Output() LockSearch: EventEmitter<any> = new EventEmitter();

	//Custom Filtering
	StartDate: Date = new Date(2000, 0, 1, 6, 0, 0);
	EndDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59);

	// StartTime: Date = new Date(2000, 0, 1, 6, 0, 0);
	// EndTime: Date = new Date();

	// WrapTime: any = true;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	@Input() lstIncidents: any;

	lstFilteredIncidents: any = [];
	SelectedIncidents: any;

	//Filter lists
	lstSchoolName: any = [];
	lstInfractionDesc: any = [];
	lstPenaltyDesc: any = [];
	lstActiveDesc: any = [];
	lstAlertDesc: any = [];
	lstPartOfGroupDesc: any = [];
	lstContinueAlertDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'AlertDesc', header: 'Alert' },
		{ field: "StudentName", header: "Student" },
		{ field: "SchoolName", header: "School" },
		{ field: "IncidentDTDesc", header: "Date/Time" },
		{ field: "InfractionDesc", header: "Infraction" },
		{ field: "PenaltyDesc", header: "Action" },
		{ field: "ActiveDesc", header: "Student Active" },
		{ field: "PartOfGroupDesc", header: "Part of Group Action" },
		{ field: "GroupName", header: "Group" },
		// { field: 'ContinueAlertDesc', header: 'Continue Alert' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadCurrentYearStartDate() {
		var result = this.studentAlertService.CurrentYearStartDateSelect();
		result.subscribe(
			(response: any) => {
				this.StartDate = new Date(response.StartDate);
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.RefreshTable.emit(1);
	}

	//Custom Button Methods
	onRemoveAlert() {
		this.errorMessage = "";

		//Error handling
		this.confirmationService.confirm({
			key: "confirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "You are about to deactivate " + this.SelectedIncidents.length + " alerts. Do you want to continue?",
			header: "Confirm Deactivate Alerts",
			icon: "fa",
			accept: () => {
				this.onFinishRemoveAlerts();
			},
		});
	}

	onFinishRemoveAlerts() {
		//Create request model
		this.loading = true;
		this.LockSearch.emit(true);

		var IDList: number[] = [];

		for (var i = 0; i < this.SelectedIncidents.length; i++) {
			var next = this.SelectedIncidents[i];

			IDList = [...IDList, next.IncidentID];
		}

		var ReqMod: RemoveAlertsRequestModel = {
			IncidentIDs: IDList,
		};

		//Call SP
		var result = this.studentAlertService.RemoveAlerts(ReqMod);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRefresh();
					this.loading = false;
					this.LockSearch.emit(false);
				} else {
					this.confirmationService.confirm({
						key: "table",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not remove alerts from the selected Incidents",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.loading = false;
							this.LockSearch.emit(false);
						},
					});
				}
			},
			(error) => {}
		);
	}

	onDeleteIncidents() {
		this.errorMessage = "";

		//Error handling
		this.confirmationService.confirm({
			key: "confirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "You are about to DELETE " + this.SelectedIncidents.length + " Incidents. Do you want to continue?",
			header: "Confirm Delete Incidents",
			icon: "fa",
			accept: () => {
				this.onFinishDeleteIncidents();
			},
		});
	}

	onFinishDeleteIncidents() {
		//Create request model
		this.loading = true;
		this.LockSearch.emit(true);

		var IDList: number[] = [];

		for (var i = 0; i < this.SelectedIncidents.length; i++) {
			var next = this.SelectedIncidents[i];

			IDList = [...IDList, next.IncidentID];
		}

		var ReqMod: RemoveAlertsRequestModel = {
			IncidentIDs: IDList,
		};

		//Call SP
		var result = this.studentAlertService.DeleteIncidents(ReqMod);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.onRefresh();
					this.loading = false;
					this.LockSearch.emit(false);
				} else {
					this.confirmationService.confirm({
						key: "table",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete alerts from the selected Incidents",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.loading = false;
							this.LockSearch.emit(false);
						},
					});
				}
			},
			(error) => {}
		);
	}

	onMergeToGroup() {
		this.errorMessage = "";

		//Error handling

		//Call SP
	}

	// onWrapTime(){
	//   this.WrapTime = true;
	// }

	// onNoWrapTime(){
	//   this.WrapTime = false;
	// }

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	//Custom filtering
	onStartDateChange(val) {
		this.StartDate = val;
		// this.RefreshTable.emit(1);
	}
	onEndDateChange(val) {
		this.EndDate = val;
		// this.RefreshTable.emit(1);
	}

	// onStartTimeChange(val){
	//   this.StartTime = val;
	//   // this.RefreshTable.emit(1);
	// }

	// onEndTimeChange(val){
	//   this.EndTime = val;
	//   // this.RefreshTable.emit(1);
	// }

	// onWrapTimeChange(val){
	//   this.WrapTime = val;
	//   // this.RefreshTable.emit(1);
	// }

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		// this.SelectedIncident = val.data;
	}
	onRowUnselect(val) {
		// this.SelectedIncident = null;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	UpdateFilterLists() {
		this.loading = true;
		this.LockSearch.emit(true);

		this.SelectedIncidents = [];

		this.lstSchoolName = [];
		this.lstInfractionDesc = [];
		this.lstPenaltyDesc = [];

		// this.lstAlertDesc = Array.from(new Set(this.lstFilteredIncidents.map((item: any) => item.AlertDesc)));
		this.lstSchoolName = Array.from(new Set(this.lstIncidents.map((item: any) => item.SchoolName))).sort();
		this.lstInfractionDesc = Array.from(new Set(this.lstIncidents.map((item: any) => item.InfractionDesc))).sort();
		this.lstPenaltyDesc = Array.from(new Set(this.lstIncidents.map((item: any) => item.PenaltyDesc))).sort();
		this.lstActiveDesc = Array.from(new Set(this.lstIncidents.map((item: any) => item.ActiveDesc))).sort();
		this.lstPartOfGroupDesc = Array.from(new Set(this.lstIncidents.map((item: any) => item.PartOfGroupDesc))).sort();
		this.lstContinueAlertDesc = Array.from(new Set(this.lstIncidents.map((item: any) => item.ContinueAlertDesc))).sort();

		this.loading = false;
		this.LockSearch.emit(false);
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			if (this.user.userID == 0) {
				return true;
			} else {
				return false;
			}
		}
	}

	////////////////////////////////////////////
}
